__turbopack_context__.v({
  "container": "article-cover-module-scss-module__caU-cq__container",
  "image": "article-cover-module-scss-module__caU-cq__image",
  "skeleton": "article-cover-module-scss-module__caU-cq__skeleton",
});
